export default {"src":"/_next/static/media/chevron-left-outline.35c0fff6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};